<template>
  <div class="c-button-purchase">
    <button-add-to-cart
      v-if="product.isActionAvailable"
      :items="items"
      :disabled="isProcessing || undefined"
      size="small"
    />

    <f-button
      v-else-if="product.isSoldout"
      :disabled="true"
      html-tag="span"
      size="small"
    >
      SOLD OUT
    </f-button>

    <!-- 入荷待ち -->
    <f-button
      v-else-if="product.isBackstock"
      size="small"
      html-tag="button"
      type="button"
      className="BIS_trigger"
      outline
      :attribute="{ 'data-product-data': JSON.stringify(product) }"
      :preventDefault="true"
    >
      {{ registerForStockAlertButtonText }}
    </f-button>

    <!-- 商品詳細 -->
    <f-button
      v-else-if="product.isExhibit"
      size="small"
      outline
      :href="product.url"
    >
      詳細を確認する
    </f-button>
  </div>
</template>

<script>
import { isDesktop } from '~/js/templates/index/helpers'
import Product from '~/js/models/product'
import OSProduct from '~/js/models/OSProduct'

import ButtonAddToCart, { ItemAddToCart } from '~/js/components/buttonAddToCart'
import FButton from '~/js/components/button'

export default {
  name: 'ComponentProductCardButtonArea',
  props: {
    product: {
      type: [Product, OSProduct],
      required: true,
      default: () => {
        return new Product()
      },
    },
  },
  components: {
    FButton,
    ButtonAddToCart,
  },
  data() {
    return {
      isProcessing: false,
    }
  },
  computed: {
    items() {
      return [new ItemAddToCart(this.product)]
    },
    registerForStockAlertButtonText() {
      const isWishlist = window.location.href.includes('?view=productlist')
      return !isDesktop() && !isWishlist
        ? '入荷通知を登録'
        : '入荷通知を受け取る'
    },
  },
}
</script>

<style lang="scss" scoped>
.c-button-add-to-cart {
  &__icon {
    font-size: 16px;
    line-height: 1;
    margin-right: 5px;
  }
}
</style>
